/* eslint-disable react/require-default-props */
import { ChevronRight } from '@mui/icons-material';
import { Stack, Tooltip, Typography } from '@mui/material';
import SelectableCard from 'components/SelectableCard/SelectableCard';
import React, { forwardRef, ReactNode } from 'react';
import { TOnClick } from 'types/props';

interface IPageBarButtonProps {
	text: string;
	rightContent?: ReactNode;
	onClick?: TOnClick;
	disabled?: boolean;
	'data-testid'?: string;
	tooltip?: ReactNode;
}

const PageBarButton = forwardRef<HTMLDivElement, IPageBarButtonProps>(
	(
		{
			text,
			rightContent = null,
			onClick = undefined,
			disabled = false,
			'data-testid': dataTestId = 'page-bar-button',
			tooltip = ''
		},
		ref
	) => (
		<Tooltip title={tooltip}>
			<SelectableCard
				ref={ref}
				sx={{ flexGrow: 1 }}
				data-testid={dataTestId}
				onClick={onClick}
				actionsAreaProps={{ sx: { px: 3 } }}
				disabled={disabled}
			>
				<Stack
					height={80}
					direction="row"
					justifyContent="space-between"
					alignItems="center"
				>
					<Typography variant="subtitle1">{text}</Typography>
					<Stack direction="row" gap={3} alignItems="center">
						<Stack direction="row" gap={1}>
							{rightContent}
						</Stack>
						<ChevronRight />
					</Stack>
				</Stack>
			</SelectableCard>
		</Tooltip>
	)
);

export default PageBarButton;
